import { render, staticRenderFns } from "./SurveyView.vue?vue&type=template&id=15d36bd1&scoped=true&lang=pug"
import script from "./SurveyView.vue?vue&type=script&lang=js"
export * from "./SurveyView.vue?vue&type=script&lang=js"
import style0 from "./SurveyView.vue?vue&type=style&index=0&id=15d36bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d36bd1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoCrmClientAlert: require('/home/docker/code/frontend/components/NoCrmClientAlert.vue').default,InactiveClientAlert: require('/home/docker/code/frontend/components/InactiveClientAlert.vue').default,SurveyHeader: require('/home/docker/code/frontend/components/survey/SurveyHeader.vue').default,SurveyFooter: require('/home/docker/code/frontend/components/survey/SurveyFooter.vue').default})
